module.exports = __webpack_public_path__ + "static/img/16036B_2_3_R_20191118_LC.8daf151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16036B_2_3_R_20191118_LC.png
// module id = vK3M
// module chunks = 0